export default "/images/module_icons_w_bg_color_hand.png?066791473eece3a098f085728e249c11";